var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "action-section mt-2 mb-4", class: _vm.mainContainerStyle },
    [
      !_vm.actionObject.state
        ? _c(
            "div",
            {
              staticClass:
                "relative flex flex-row p-1 customHeightSkill items-center",
              class: _vm.parentStyle,
            },
            [
              _c("div", { staticClass: "flex flex-col items-center w-full" }, [
                _c("div", { staticClass: "projects-value" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.actionObject.default.leftValue
                          ? _vm.actionObject.default.leftValue
                          : `n/a`
                      ) +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "projects-name" }, [
                  _vm._v(
                    " " + _vm._s(_vm.actionObject.default.leftTitle) + " "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "ml-2 mr-2 h-6 w-1 addColor" }),
              _vm._t("rightSection"),
              _vm.actionObject.default.rightTitle
                ? _c(
                    "div",
                    { staticClass: "flex flex-col items-center w-full" },
                    [
                      _c("div", { staticClass: "projects-value" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.actionObject.default.rightValue
                                ? _vm.actionObject.default.rightValue
                                : `n/a`
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "projects-name" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.actionObject.default.rightTitle) +
                            " "
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm.actionObject.state
        ? _c(
            "div",
            {
              staticClass:
                "relative flex flex-col p-1 min-h-11 justify-center h-auto items-center",
              class: _vm.resourceHeight,
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-row gap-1 !items-center justify-center",
                },
                [
                  _c("img", {
                    staticClass: "h-4 w-4",
                    attrs: {
                      src: require("@/assets/alert-circle.svg"),
                      alt: "",
                    },
                  }),
                  _c("div", { staticClass: "error-title" }, [
                    _vm._v(_vm._s(_vm.actionObject.error.title)),
                  ]),
                ]
              ),
              _vm.actionObject.error.actionButton
                ? _c(
                    "div",
                    [
                      _vm.actionObject.error.actionButton === "internal"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "relative flex flex-col p-1 min-h-11 justify-center h-auto items-center",
                            },
                            [
                              _c("div", { staticClass: "internal-message" }, [
                                _vm._v(
                                  " Profile has been internally added to database. Resource not invited. "
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm.actionObject.error.actionButton === "resend"
                        ? _c("ResendInvitationWrapper", {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ setInvitationSentStatus }) {
                                    return [
                                      !_vm.isContractor
                                        ? _c("ManagerResendInvitation", {
                                            attrs: {
                                              adminUserId: _vm.currentUser.id,
                                              managerId: _vm.manager.id,
                                              givenName:
                                                _vm.manager.user.given_name,
                                              familyName:
                                                _vm.manager.user.family_name,
                                            },
                                            on: {
                                              invitationResent:
                                                setInvitationSentStatus,
                                            },
                                          })
                                        : _c("ContractorResendInvitation", {
                                            attrs: {
                                              showSmallButton: true,
                                              companyId: _vm.companyId,
                                              contractorId: _vm.contractorId,
                                              invitedByUserId:
                                                _vm.currentUser.id,
                                              givenName:
                                                _vm.contractor.user.given_name,
                                              familyName:
                                                _vm.contractor.user.family_name,
                                            },
                                            on: {
                                              invitationResent: function (
                                                $event
                                              ) {
                                                return setInvitationSentStatus()
                                              },
                                            },
                                          }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4019453822
                            ),
                          })
                        : _vm._e(),
                      _vm.actionObject.error.actionButton === "activate"
                        ? _c(
                            "ManagerInvitationDisabledTooltip",
                            {
                              staticClass:
                                "flex items-center justify-center h-full",
                              attrs: { disabled: _vm.allowedActivateManagers },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "flex items-center justify-center gap-1 w-full focus:outline-none",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _vm.onActivateManager &&
                                        _vm.onActivateManager()
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "h-5 w-5",
                                    attrs: {
                                      src: require("@/assets/up-right-icon.svg"),
                                      alt: "resend",
                                    },
                                  }),
                                  _c("span", { staticClass: "invite-text" }, [
                                    _vm._v("Activate"),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._t("customAction"),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }